import { Checkbox, TablePagination, TableCell, Avatar, AvatarGroup } from '@mui/material';
import { useSelector } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import ThreeDotMenu from './ThreeDotMenu';
import {
  CustomTableCellForBody,
  CustomTableCellForNoData,
  CustomTableView,
} from '../../../components/UI/CustomTableView';
import defaultCard from '../../../assets/defaultCard.png';
import useUserTimeZone, { getTimeZoneAbbreviation } from '../../../hooks/useUserTimeZone';
import useSortHook from '../../../hooks/useSortHook';
import useProfileImage from '../../../hooks/useProfileImage';

const tableCellPStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '250px',
  maxHeight: '100px',
};

const TableViewTask = ({
  data,
  paginationData,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDisplay,
  onDelete,
  onSelectedChange,
  selectedAccount,
  onChangeLog,
  peopleAccepted,
}) => {
  const { user } = useSelector((state) => state.login);
  const { handleSort, newSortData, sortState } = useSortHook(data, ['purchaseDate']);
  const { expiryCheck, formatDate } = useUserTimeZone();
  const handleDoubleClick = (event, data) => {
    if (event.detail === 2) {
      onDisplay(data);
    }
  };

  const headData = ['Actions', 'Event', 'Task Description', 'Planning Phase', 'Estimate Timeline', 'Notes', 'Assignee'];

  // const amountSym = user.country === 'United States' ? '$' : '₹';

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '48px' }}>
        {selectedAccount?.length > 0 ? (
          <div>
            <span>
              <b>{selectedAccount?.length}</b> selected
            </span>
          </div>
        ) : (
          <span />
        )}

        <TablePagination
          component="div"
          size="small"
          count={paginationData?.total ?? 0}
          rowsPerPageOptions={[10, 15, 25, 50, 100]}
          rowsPerPage={paginationData?.limit ?? 15}
          page={paginationData.page - 1}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </div>
      <TableContainer sx={{ maxHeight: 600 }}>
        <CustomTableView
          isSort
          sort={{
            order: sortState.order,
            orderBy: sortState.orderBy,
            createSortHandler: handleSort,
            sortHeadMap: ['', 'event.name', 'description', 'planningPhase', 'timeline', 'notes', ''],
          }}
          headData={headData}
        >
          {data.length === 0 && (
            <CustomTableCellForNoData message={`There are no recorded event task for you. Kindly add a new one.`} />
          )}
          {newSortData?.map((e, index) => {
            const isIamOwner = e?.createdBy === user._id || e?.eventOwner === user?._id;

            return (
              <TableRow key={index} onClick={(ev) => handleDoubleClick(ev, e)}>
                <CustomTableCellForBody align="center" padding="checkbox">
                  <div style={{ display: 'flex' }}>
                    {/* <Checkbox checked={selectedAccount.includes(e._id)} onChange={() => onSelectedChange(e._id)} /> */}
                    <ThreeDotMenu
                      // onChangeLog={() => onChangeLog(e)}
                      data={e}
                      onEdit={
                        isIamOwner &&
                        ((flag) => {
                          if (flag) {
                            onDisplay(e);
                          } else {
                            onEdit(e);
                          }
                        })
                      }
                      onDisplay={() => onDisplay(e)}
                      onDelete={isIamOwner && (() => onDelete(e))}
                    />
                  </div>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="center">
                  <p style={tableCellPStyle}>{e?.event?.name}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.description}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.planningPhase}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.timeline}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.notes}</p>
                </CustomTableCellForBody>
                <CustomTableCellForBody align="left">
                  {/* <p style={tableCellPStyle}> */}
                  <AvatarGroup
                    // // onClick={onOpenBuddy}
                    // onClick={() => {
                    //   navigate('/safalbuddy?status=pending');
                    // }}
                    sx={{ marginRight: '32px', '& .MuiAvatar-root': { width: 26, height: 26, fontSize: 16 } }}
                    max={8}
                  >
                    {e?.assignee?.map((e, index) => (
                      <ReturnAvatar key={index} data={e} peopleAccepted={peopleAccepted} />
                    ))}
                  </AvatarGroup>
                  {/* </p> */}
                </CustomTableCellForBody>
                {/* <CustomTableCellForBody align="left">
                  <p style={tableCellPStyle}>{e?.status}</p>
                </CustomTableCellForBody> */}
              </TableRow>
            );
          })}
        </CustomTableView>
      </TableContainer>
    </>
  );
};

export default TableViewTask;

const ReturnAvatar = ({ data, peopleAccepted }) => {
  const { user } = useSelector((state) => state.login);
  const _peopleAccepted = [...peopleAccepted, user];
  const findPeople = _peopleAccepted?.find((e) => e?._id === data?.user);
  const profileImage = useProfileImage(findPeople?.profilePic);
  const fullName = `${findPeople?.firstName} ${findPeople?.lastName}`;
  return <Avatar alt={fullName} src={profileImage} />;
};
